module.exports = __webpack_public_path__ + "img/id_img_bg.96b719b0.png";